import Vue from 'vue'
import VueResource from 'vue-resource'
import router from '@/router'

import db_list from './db/list'
import db_objects from './db/objects'
import datastore_favorites from './datastore/favorites'
import datastore_meta from './datastore/meta'
import datastore_notifications from './datastore/notifications'
import theme from './theme'


Vue.use(VueResource)

let dataLayerEnrich = (e, p) => {
    let dataLayer = window.dataLayer || [];
    dataLayer.push({ 'event': e, 'data': p })
}

export default {
    ...theme,
    ...db_list,
    ...db_objects,
    ...datastore_favorites,
    ...datastore_meta,
    ...datastore_notifications,
    authorizeUser(context, payload) {
        context.state.progress.log = true
        let flow = payload.flow
        let data = payload.user
        let authority = ''
        switch (flow) {
            case 'start':
                authority = `Plain ${data.login.toLowerCase()}:${data.password}`
                break
            case 'resume':
                authority = `Bearer ${context.getters.userToken}`
                break
            case 'social':
                authority = `External ${data.email}`
                break;
        }
        let requestHeaders = {
            'Content-Type': 'application/json; charset=UTF-8',
            'Authorization': authority
        }
        Vue.http.post(
            context.getters.authHandler + '/login', {user: data}, { headers: requestHeaders }
        ).then((r) => {
            if (r.body.result) {
                context.state.progress.log = false
                context.state.progress.retreive = true;
                let ah = {
                    'X-Appengine-Inbound-Appid': r.headers.get('X-Appengine-Inbound-Appid'),
                    'X-Auth-User': String(r.body.user['uid']),
                    'X-Auth-State': String(r.body.user['superuser']),
                    'Authorization': `Bearer ${r.body.user['token']}`
                }
                context.commit('authHeaders', ah)
                context.commit('authorize', {'user': r.body.user});
                context.dispatch('requestUserMeta')
                Vue.http.post(
                    context.getters.endpoint + '/db/objects', {}, { headers: ah }
                ).then((o) => {
                    let user = o.data
                    context.state.progress.retreive = false
                    if (!user.result && flow == 'resume') {
                        context.dispatch('deauthorizeUser')
                    }
                    delete user.result
                    context.commit('authorize', user);
                    context.dispatch('requestUserNotifications')
                    dataLayerEnrich('auth', {
                        type: flow == 'resume' ? 'resume' : 'login',
                        uid: context.getters.currentUser.uid,
                        email: context.getters.currentUser.login,
                        auth_type: flow
                    });
                    if (!data.persistance) {
                        window.addEventListener('beforeunload', () => { context.dispatch('deauthorizeUser') })
                    }
                    if (router.currentRoute.query.redirect) {
                        router.push(router.currentRoute.query.redirect);
                    } else {
                        if (router.currentRoute.name == 'auth') {
                            router.push('/')
                        }
                    }
                });
            } else {
                let user = r.body
                context.state.progress.log = false
                if (flow == 'resume') {
                    context.dispatch('deauthorizeUser')
                }
                if (user.reason == 'login not found' || user.reason == 'lookup') {
                    context.commit('authErrorEmail', 'Неверный логин')
                }
                if (user.reason == 'Empty or short password') {
                    context.commit('authErrorPassword', 'Слишком короткий пароль')
                }
                if (user.reason == 'challenge failed') {
                    context.commit('authErrorPassword', 'Неверный пароль')
                }
            }
        });
    },
    deauthorizeUser(context) {
        context.state.progress.log = true;
        Vue.http.post(
            context.getters.authHandler + '/logout', {}, { headers: { 'Content-Type': 'application/json; charset=UTF-8' } }
        ).then((r) => {
            dataLayerEnrich('auth', {
                type: 'logout',
                email: context.getters.currentUser.email,
                uid: context.getters.currentUser.uid
            });
            context.state.progress.log = false;
            context.commit('exitSystem');
            router.push({ 'path': '/auth', 'query': { 'redirect': '/' } });
        });
    }
}
